import React, { useEffect, useState, useCallback } from "react";
import { Table, Button } from "antd";
import momentTimezone from "moment-timezone";
import Timeslot from "../Timeslots/Timeslot";
import { fetchSpecialistsAvailableTime, deleteAvailableTime } from "../../../../api/specialists";
import "./index.css";
import moment from "moment";
import { STATUS, TIME_FORMAT } from "../../../../constants";

const { DATE: DATE_FORMAT, MONTH: MONTH_FORMAT, DATE_WITH_DASH, DATE_WITH_TIME, HOUR_AND_MIN } = TIME_FORMAT;

const AvailableTimeTable = ({ specialistId, latestSelectedMoment, createStatus, timezone }) => {
  const [availableTimeInThisMonth, setAvailableTimeInThisMonth] = useState([]);
  const [deletingStates, setDeletingStates] = useState({});

  const fetchAvailableTime = useCallback(async () => {
    const month = latestSelectedMoment.format(MONTH_FORMAT);
    const result = await fetchSpecialistsAvailableTime(specialistId, month);
    const availableTimes = result?.data?.map(({ date, timezone: originTimezone, timeslots }) => {
      const timeslotsWithTZ = timeslots.map(({ start, end, selectedRoom }) => {
        const startTime = momentTimezone.tz(`${date}${start}`, DATE_WITH_TIME, originTimezone).format();
        const endTime = momentTimezone.tz(`${date}${end}`, DATE_WITH_TIME, originTimezone).format();
        return {
          selectedRoom,
          start: momentTimezone.tz(startTime, timezone).format(HOUR_AND_MIN),
          end: momentTimezone.tz(endTime, timezone).format(HOUR_AND_MIN),
        };
      });

      return {
        date,
        timeslots: timeslotsWithTZ,
      };
    });
    setAvailableTimeInThisMonth(availableTimes);
  }, [latestSelectedMoment, specialistId, timezone]);

  const deleteAvailableTimeRow = async (date, specialistId) => {
    setDeletingStates({ ...deletingStates, [date]: true });
    const result = await deleteAvailableTime({ specialistId, date });
    if (result.successful) {
      await fetchAvailableTime();
    } else {
      alert(result.message);
    }
    setDeletingStates({ ...deletingStates, [date]: false });
  };

  useEffect(() => {
    if (specialistId && latestSelectedMoment) {
      fetchAvailableTime();
    } else {
      setAvailableTimeInThisMonth([]);
    }
  }, [specialistId, latestSelectedMoment, timezone, fetchAvailableTime]);

  useEffect(() => {
    if (specialistId && createStatus.status === STATUS.SUCCEED && latestSelectedMoment) {
      fetchAvailableTime();
    }
  }, [specialistId, createStatus, latestSelectedMoment, fetchAvailableTime]);

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => {
        return <div>{moment(date, DATE_FORMAT).format(DATE_WITH_DASH)}</div>;
      },
      width: 150,
      sorter: ({ date: dateA }, { date: dateB }) => {
        if (moment(dateA, DATE_FORMAT).isAfter(moment(dateB, DATE_FORMAT))) {
          return 1;
        }

        if (moment(dateA, DATE_FORMAT).isSame(moment(dateB, DATE_FORMAT))) {
          return 0;
        }

        if (moment(dateA, DATE_FORMAT).isBefore(moment(dateB, DATE_FORMAT))) {
          return -1;
        }
      },
    },
    {
      title: "Time slots",
      dataIndex: "timeslots",
      render: (timeslots) => {
        return (
          <>
            {timeslots.map(({ start, end, selectedRoom }, index) => {
              return <Timeslot start={start} end={end} key={index} showCloseIcon={false} selectedRoom={selectedRoom} />;
            })}
          </>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "date",
      width: 100,
      render: (date) => {
        return (
          <Button
            type="link"
            onClick={(e) => {
              deleteAvailableTimeRow(date, specialistId);
            }}
            loading={deletingStates[[date]]}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  return (
    <Table
      scroll={{ y: 260, x: 0 }}
      className="specialist-available-time"
      columns={columns}
      rowKey="date"
      dataSource={availableTimeInThisMonth}
      bordered
    />
  );
};

export default AvailableTimeTable;
